import { atomWithReset } from "jotai/utils";
import { UserDataRow } from "./UserTable.types";

export const UserAtoms = {
  selectedUser: atomWithReset<UserDataRow | null>(null),
};
